import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';
export const findProductCouponDetail= (id,params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/coupon-detail/${id}?`+params,
        method: 'GET'
    })
}